import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {withRouter} from "react-router";
import {Redirect} from "react-router-dom";
import {useFormik} from 'formik';
import {loginUser} from '../../../services/auth.service';
import {useAuth} from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import PoweredbyDQ from "../../../assets/images/PoweredByDQ_Default.png"
import 'aos/dist/aos.css'
import AOS from 'aos'

const useStyles = makeStyles((theme) => ({
    textField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            '&.Mui-focused': {
                backgroundColor: '#ffffff',
            },
            '&.MuiInputBase-root.Mui-disabled': {
                backgroundColor: '#f5f5f5',
            },
            '& input:-webkit-autofill': {
                boxShadow: '0 0 0 100px #ffffff inset !important',
                WebkitBoxShadow: '0 0 0 100px #ffffff inset !important',
                WebkitTextFillColor: '#000000 !important',
            },
            '& fieldset': {
                borderColor: '#ff7676',
                borderWidth: 1,
            },
            '&:hover fieldset': {
                borderWidth: 1,
                borderColor: '#ff7676',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ff7676',
                borderWidth: 1,
            },
        },
        '& .MuiInputBase-input': {
            color: '#000000',
            padding:'15.5px 14px',
        },
        '& .MuiInputLabel-root': {
            color: '#ff7676',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff7676',
        },
    },
    paper: {
        backgroundColor: "#F4EEEE",
        color: theme.palette.loginPage.text,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontFamily: 'Surt',
        [theme.breakpoints.down('sm')]: {
           height:'73vh',
        }
    },
    form: {
        width: '78%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        color: theme.palette.background.default,
        fontFamily: 'Surt',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        color: '#ffffff',
        width: '100%',
        fontSize: '21px',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
    },
    section1: {

        height: '80%',
        fontFamily: 'Surt',
        '@media (min-width: 768px) and (max-width: 960px)': {
            height: '75%',
        },
        '@media (min-width: 960px) and (max-width: 1024px)': {
            height: '40%',
        },
    },

}));

const Login = (props) => {
    // const [isLoggedIn, setLoggedIn] = useState(false);
    const classes = useStyles();

    const {setAuthToken, setAuthUser} = useAuth();
    const referer = props.location.referer || '/dq_pro/home';
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            remember_me: false
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);
            try {
                setLoading(true);
                const result = await loginUser(values.email, values.password, values.remember_me);
                console.log('result.data -> ', result.data);
                if (result.data && result.data.user) {
                    await setAuthToken(result.data.auth_token);
                    await setAuthUser(result.data.user);
                    localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));
                    localStorage.setItem(LOCAL_STORAGE_KEYS.user_email, JSON.stringify(result.data.user.email));
                    return <Redirect to={referer}/>;
                    // setLoggedIn(true);
                }
                setLoading(false);
            } catch (e) {
                // already toasted the error
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        AOS.init({
            duration: 500,
        });
    }, []);

    return (
        <>
           <Grid container className={classes.section1} data-aos="fade-in" data-aos-delay='100' style={{backgroundColor:"#F4EEEE", height:'100vh'}}>
                    <Container component="main" maxWidth="sm" style={{
                            marginTop:'10%',}}>
                       <div className={classes.paper} style={{
                                paddingBottom: '50px',
                                backgroundColor:'#F4EEEE',
                       }}>
                                <img src={PoweredbyDQ} alt="Image"
                                     style={{
                                         width: '250px',
                                         cursor: 'pointer'
                                     }}/>
                                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}
                                      style={{fontFamily: 'Surt'}}>
                                    <TextField
                                        className={classes.textField}
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        name="email"
                                        autoComplete="email"
                                        autoFocus
                                        onChange={formik.handleChange}
                                        value={formik.values.email}
                                    />
                                    <TextField
                                        className={classes.textField}
                                        style={{borderRadius: '30px'}}
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        onChange={formik.handleChange}
                                        value={formik.values.password}
                                    />
                                    <Grid container>
                                        <FormControlLabel
                                            control={<Checkbox
                                                name="remember_me"
                                                id="remember_me"
                                                value={formik.values.remember_me}
                                                onChange={formik.handleChange}
                                            />}
                                            label="Remember me"
                                            style={{color: '#ff7676', fontFamily: 'Surt'}}
                                        />
                                        <Grid item xs style={{
                                            textAlign: 'right',
                                            paddingTop: '2%',
                                            fontFamily: 'Surt',
                                            color: '#ff7676'
                                        }}>
                                            <Link href="/account/recover" variant="body2">
                                                Forgot password?
                                            </Link>
                                        </Grid>
                                    </Grid>
                                    <Typography align='center'>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: '#ff6468',
                                                width: '50%',
                                                mt:3,
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                borderRadius: '20px',
                                                '&:hover': {
                                                    backgroundColor: '#ff6468',
                                                    color:'#ffffff'
                                                }
                                            }}
                                        >
                                            Sign In
                                        </Button>
                                    </Typography>

                                    <Grid item style={{textAlign: 'center',marginTop:'50px', fontFamily: 'Surt',color: '#000000',}}>
                                        <Typography align='center' style={{fontWeight:'bold',fontSize:'19px'}}>
                                            Don’t have an account?
                                        </Typography>
                                            <Typography align='center' style={{fontSize:'19px'}}>
                                                Sign up to join Powered by DQ {' '}
                                            <Link target='_blank' href="/signup" variant="body2" style={{textDecoration:'underline',fontWeight:'bold',color: '#ff7676',fontSize:'21px'}}>
                                            {"here"}
                                        </Link>
                                        </Typography>
                                    </Grid>

                                </form>
                            </div>

                            <LoaderWithBackDrop loading={loading}/>
                        </Container>
                    </Grid>
                {/*</Grid>*/}
        </>
    );
}

export default withRouter(Login);